var _stop, _stop2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgLeftTop = function SvgLeftTop(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.9485 14.5V7.62179C11.3196 3.53205 13.4845 0.991453 17.4433 0V2.97436C16.8247 3.34615 16.3299 3.71795 15.9588 4.08974C15.2165 4.95726 14.9072 5.51496 15.0309 5.76282V7.0641H18V14.5H10.9485ZM0 14.5V7.62179C0.618557 3.28419 2.78351 0.74359 6.49485 0V2.97436C5.01031 3.71795 4.20619 4.64744 4.08247 5.76282V7.0641H7.05155V14.5H0Z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: -9,
    y1: 3.99358,
    x2: -1.99326,
    y2: 19.7841,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC73"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA81F"
  })))));
};
export default SvgLeftTop;